"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_jss_1 = require("react-jss");
var Typography_1 = __importDefault(require("../Typography"));
var classnames_1 = __importDefault(require("classnames"));
var defaultProps = {
    danger: false,
};
var useStyles = (0, react_jss_1.createUseStyles)(function (_a) {
    var colors = _a.colors;
    return ({
        dropdownMenuItem: {
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            display: 'flex',
            alignItems: 'center',
            padding: '0 16px',
            height: 40,
            '&:hover': {
                backgroundColor: colors.Hannibal['100'],
            },
        },
        danger: {
            color: colors.Red['600'],
        },
    });
});
var DropdownMenuItem = function (props) {
    var _a, _b;
    var style = props.style, children = props.children, danger = props.danger, onClick = props.onClick;
    var styles = useStyles();
    return (react_1.default.createElement("div", { onClick: onClick, className: (0, classnames_1.default)(styles.dropdownMenuItem, (_a = {}, _a[styles.danger] = danger, _a)), style: style },
        react_1.default.createElement(Typography_1.default, { style: { color: 'inherit' }, className: (0, classnames_1.default)((_b = {}, _b[styles.danger] = danger, _b)), component: "div", margin: 'none', variant: 'textMedium' }, children)));
};
DropdownMenuItem.defaultProps = defaultProps;
exports.default = DropdownMenuItem;
//# sourceMappingURL=DropdownMenuItem.js.map